import React from 'react'
import i18n from '@pureartisan/simple-i18n'
import LevelScale from '../LevelScale'
import Tooltip from '../Tooltip'
import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import TuneIcon from '@material-ui/icons/TuneOutlined'
import ScoreScale from '../ScoreScale/'

// Styles for this component.
const useStyles = makeStyles(theme => ({
  root: {},
  headingRow: {
    paddingBottom: theme.spacing(1),
    '& h2': {
      lineHeight: '32px',
    },
  },
  openControlButton: {
    minWidth: 'unset',
    background: theme.extras.variables.colors.accent,
    marginLeft: theme.spacing(1.5),
    width: '40px',
    height: '40px',
    '& svg': {
      color: theme.palette.secondary.main,
    },
    '&.Mui-disabled svg': {
      color: theme.extras.variables.colors.textSubtle,
    },
  },
}))

const LegendScale = ({
  activeMetric,
  activeNorm,
  activeGeoType,
  activeRatingType,
  activeYear,
  hoveredRating,
  openControlHandler,
  headingless,
  controlPanelOpen,
}) => {
  const classes = useStyles()
  const controlPanelTooltip = i18n.translate(
    controlPanelOpen
      ? `DATA_CONTROLS_OPEN`
      : `OPEN_DATA_CONTROLS`,
  )
  return (
    <Box id="legend-scale" className={classes.root}>
      {!headingless && (
        <Box display="flex" className={classes.headingRow}>
          <Typography
            variant="h2"
            className={classes.heading}
            dangerouslySetInnerHTML={{
              __html: i18n.translate(
                `LEGEND_HEADING_${activeRatingType}`,
              ),
            }}
          />
        </Box>
      )}
      <Box display="flex">
        <Typography
          variant="body1"
          color="textSecondary"
          dangerouslySetInnerHTML={{
            __html: i18n.translate(`LEGEND_CAPTION`, {
              metric: i18n.translate(
                `LEGEND_METRIC_${activeMetric}`.toUpperCase(),
              ),
              geoType: i18n.translate(
                `LEGEND_GEO_TYPE_${activeGeoType}`.toUpperCase(),
              ),
              norm: i18n.translate(
                `LEGEND_NORMLY_${activeNorm}`.toUpperCase(),
              ),
              year: i18n.translate(`LEGEND_${activeYear}`),
            }),
          }}
        />
        {openControlHandler && (
          <Tooltip title={controlPanelTooltip}>
            <Button
              disableRipple={true}
              disabled={controlPanelOpen}
              aria-label={controlPanelTooltip}
              className={clsx(
                classes.openControlButton,
                'screenshot-ignore',
              )}
              onClick={openControlHandler}
            >
              <TuneIcon />
            </Button>
          </Tooltip>
        )}
      </Box>
      {activeRatingType === 'x' && (
        <LevelScale hoveredLevel={hoveredRating} />
      )}
      {activeRatingType === 's' && (
        <ScoreScale hoveredScore={hoveredRating} />
      )}
    </Box>
  )
}

LegendScale.defaultProps = {
  classes: {},
}

export default LegendScale
